export const headerInfo = {
    title: "Provider Effort & Impact Score",
    subTitle: "Provides a synthesized view of provider burden, experience outcomes, and improvement opportunities across UnitedHealthcare. Users can monitor Provider Effort trends, identify emerging areas of friction, evaluate performance across organizational dimensions, and gain insights that support efforts to reduce administrative complexity and improve the provider experience.",
    subHeader: "Data Under Review",
    subPemTitle: "Payment Integrity Medical Records volumes and associated cost estimates are currently under review. As a result, Provider Effort measures related to Medical Records may be understated and actual provider burden could be higher than reflected in the current dashboard.",
};
export const effortIndex = "Provider Effort Score";
export const averageClaimProcessingDays = "Average Claim Processing Days";
export const claimsYield = "Claims Yield";
export const contractYieldSubHeaderText = "The yield displayed on this graph is directional only and uses estimated non-payment dollars.";
export const contractYieldFooterText = "MM/DD/YYYY - MM/DD/YYYY";
export const claimDetails = "Claims Details";
export const serviceMetrics = "Service Metrics (National Region Only)";

type FilterOption = {
    value: string;
    title: string;
    disable?: boolean;
    default?: boolean;
};
export const LOB_OPTIONS: FilterOption[] = [
    { value: 'ALL', title: 'All Lines of Business', disable: false },
    { value: 'EI', title: 'Commercial', disable: false },
    { value: 'MR', title: 'Medicare', disable: false },
    { value: 'CS', title: 'Medicaid', disable: false },
    { value: 'EXC', title: 'Individual Exchange', disable: false },
];
export const REGION_OPTIONS: FilterOption[] = [
    { value: 'National', title: 'National', disable: true },
];
export const LOB = {
    LoB: {
        title: 'LoB',
        type: 'dropDown',
        selectedValue: { ...LOB_OPTIONS.find((obj) => obj?.value === 'ALL') },
        width: '230px',
        filterOptionsSize: 'large',
        filterType: 2,
        isSorted: true,
        filterDisplayKey: 'title',
        filterValueKey: 'value',
        filterKey: 'LoB',
        key: 'LoB',
        disabled: false,
        options: [...LOB_OPTIONS],
        activeFilter: true,
        filterDisable: true,
        dropDowndisabled: false,
    },
};

export const REGION = {
    Region: {
        title: 'Region',
        type: 'dropDown',
        selectedValue: { ...REGION_OPTIONS.find((obj) => obj?.value === 'National') },
        width: '230px',
        filterOptionsSize: 'large',
        filterType: 2,
        isSorted: true,
        filterDisplayKey: 'title',
        filterValueKey: 'value',
        filterKey: 'Region',
        key: 'Region',
        disabled: true,
        options: [],
        activeFilter: false,
        filterDisable: true,
        dropDowndisabled: false,
    },
};
export const DATE = "MM/DD/YYY";
export const TIME_PERIOD = {
    timePeriod: {
        title: 'Timeperiod',
        type: 'dropDown',
        selectedValue: { title: `${DATE} - ${DATE}`, value: `${DATE} - ${DATE}` },
        width: '257px',
        filterOptionsSize: 'large',
        filterType: 1,
        isSorted: false,
        filterDisplayKey: 'value',
        filterValueKey: 'value',
        filterKey: 'timePeriod',
        key: 'timePeriod',
        disabled: true,
        options: [],
        activeFilter: false,
        filterDisable: true,
    },
};

export const peiMetricData = {
    effortIndex: {title: "Effort Index", metricId:"2301"},
    averageClaimProcessingDays: {title: "Average Claim Processing Days", metricId:"2303"},
    contractYield: {title: "Contract Yield", metricId:"2302"}
}
export const defaultFilterData = { value: 'Total', title: 'Total' };
export const seriesColors = {
    received_to_processed_tat_days: '#003DA1',
    service_to_received_tat_days: '#3381FF',
    avg_received_to_processed_tat_days: '#003DA1',
    avg_service_to_received_tat_days: '#3381FF',
  };
export const tooltipLabels = {
    received_to_processed_tat_days: 'Received to Processed',
    service_to_received_tat_days: 'Date of Service to Received',
    avg_received_to_processed_tat_days: 'Received to Processed',
    avg_service_to_received_tat_days: 'Date of Service to Received',
  };
export const effortIndexOptions: any[] = [
    { value: 'Contacts', title: 'Contacts', disable: false },
        { value: 'P2P', title: 'P2P', disable: false },
        { value: 'Medical Records', title: 'Medical Records', disable: false },
        { value: 'Reconsiderations', title: 'Reconsiderations', disable: false },
        { value: 'Appeals', title: 'Appeals', disable: false },
  ];
export const radioOptions = ['Monthly', 'Annually']
export const radioOptionsNew = ['Monthly', 'Quarterly', 'Yearly']
const createDefaultServiceMetricCard = (title: string, shortTitle: string, metricId: string) => ({
  title,
  shortTitle,
  yearToDateValue: '0',
  yearToDateValueCurrent: '0',
  yearToDateValuePrevious: '0',
  yeartoDatetitle: 'Year to Date',
  currentYearTimePeriod: 'MM/DD/YYYY - MM/DD/YYYY',
  priorYearTimePeriod: 'MM/DD/YYYY - MM/DD/YYYY',
  loader: true,
  error: false,
  timePeriod: 'MM/DD/YYYY - MM/DD/YYYY',
  metricData: { title, metricId },
  currentYearData: [],
  priorYearData: [],
  currentYearBarData: [],
  priorYearBarData: [],
});

export const appealFairness = createDefaultServiceMetricCard(
  'Appeal Fairness Star Rating Uphold Rate',
  'Appeal Rating',
  '2304'
);

export const postCallNPS = createDefaultServiceMetricCard(
  'Post Call NPS',
  'Post Call NPS',
  '2305'
);

export const secretStopper = createDefaultServiceMetricCard(
  'Secret Shopper Data Accuracy (Form Level)',
  'SS Data',
  '2307'
);

export const digitalNPS = createDefaultServiceMetricCard(
  'Digital NPS',
  'Digital NPS',
  '2306'
);

